import { useEffect, useCallback, useRef } from 'react'
import { useBlocker } from 'react-router-dom'

export function useUnsavedChangesGuard(hasUnsavedChanges: boolean) {
  const skipRef = useRef(false)

  const blocker = useBlocker(
    useCallback(() => {
      if (skipRef.current) {
        skipRef.current = false
        return false
      }
      return hasUnsavedChanges
    }, [hasUnsavedChanges])
  )

  // Warn on browser close/refresh
  useEffect(() => {
    if (!hasUnsavedChanges) return
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault()
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [hasUnsavedChanges])

  // Skip blocker for intentional navigation (after save)
  const allowNavigation = useCallback(() => {
    skipRef.current = true
  }, [])

  return { blocker, allowNavigation }
}
